import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';
export const dictionariesApi = createApi({
  reducerPath: 'dictionaries',
  baseQuery: createBaseQueryWithReauth('/dictionaries'),
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: false,
  keepUnusedDataFor: 1,

  endpoints: builder => ({
    fetchCategories: builder.query({
      query: () => '/categories',
    }),
    fetchPrices: builder.query({
      query: () => '/bag-prices',
    }),
    fetchBagStatuses: builder.query({
      query: () => '/bag-statuses',
    }),
    fetchOrderStatuses: builder.query({
      query: () => '/order-statuses',
    }),
    fetchOrganisationTypes: builder.query({
      query: () => '/organization-types',
    }),
    fetchDocumentTypes: builder.query({
      query: () => '/document-types',
    }),
    fetchBillingsPlanTypes: builder.query({
      query: () => '/billing-types',
    }),
  }),
});
export const {
  useFetchBillingsPlanTypesQuery,
  useFetchDocumentTypesQuery,
  useFetchCategoriesQuery,
  useFetchPricesQuery,
  useFetchBagStatusesQuery,
  useFetchOrderStatusesQuery,
  useFetchOrganisationTypesQuery
} = dictionariesApi;
